import { render } from "./SearchComponent.vue?vue&type=template&id=2da52b7e&ts=true"
import script from "./SearchComponent?vue&type=script&lang=ts"
export * from "./SearchComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__